import React, { useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import ReviewBox from "./ReviewBox";

import AppAlert from "../../components/AppAlert";
import PopupArea from "../../components/modal/PopupArea";
import TopPageBack from "../../components/TopPageBack";
import { WRITE_COMMENT } from "../../text-data";

export default function EditReview() {
  const [openBackConfirm, setOpenBackConfirm] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();

  const { state } = location;

  const [popupContent, setPopupContent] = useState(null);
  const closeModal = () => setPopupContent(null);

  const onBack = () => {
    setOpenBackConfirm(true)
  };
  const reviewBoxRef = useRef();
  const [textAreaHeight, setTextAreaHeight] = useState(200);

  const resizeTextArea = function () {console.log("xxxxxxxx");
    setTimeout(function () {
      // const box = reviewBoxRef.current;
      const box = document.querySelector(".review-box");
      if (!box) return;
      const height = box.offsetHeight;
      const d = window.innerHeight - height;
      if (d) {
        // const yy = d + 140;
        const yy = d + 120;
        setTextAreaHeight(yy > 200 ? yy : 200);
      }
    }, 10);
  }
  
  useState(() => {
    if (window.appBridge) {      
      window.appBridge.setEnableScroll && window.appBridge.setEnableScroll(false);          
    }
    return () => {
      if (window.appBridge) {        
        try {
          window.appBridge.setEnableScroll && window.appBridge.setEnableScroll(true);        
        } catch(e) {}        
      }
    }
  });

  return (
    <div>
      <style>
        {
          `.appbar2 {
            visibility: hidden;
          }`
        }
      </style>
      <TopPageBack padHeight="0px" style={{ backgroundColor: "#FFFFFFB2" }} onBack={onBack}>
        <b>{WRITE_COMMENT}</b>
      </TopPageBack>

      <ReviewBox {...(state?.reviewItem ?? {})}
        isEdit={true} isWriteComment={state?.isWrite} />
      <PopupArea popupContent={popupContent} closeModal={closeModal} />


      {/* Back confirm */}
      <AppAlert
        title="작성 중 내용이 저장되지 않았어요."
        desc="리뷰 목록 페이지로 돌아가시겠습니까?"
        open={openBackConfirm}
        onOk={() => {
          if (window.appBridge) {        
            try {
              window.appBridge.setEnableScroll && window.appBridge.setEnableScroll(true);        
            } catch(e) {}        
          }
          navigate(-1);
        }}
        onClose={() => setOpenBackConfirm(false)}
        okText="이동"
        cancelText="취소"
        type="error"
      />

    </div>
  );
}
